import { Icon } from 'labstep-web/core/Icon';
import type React from 'react';
import { type FC, useCallback } from 'react';
import styles from './styles.module.scss';

export interface TableDeleteHandleProps {
  position: { top: number; left: number } | null;
  onDelete: () => void;
  isVisible: boolean;
}

/**
 * TableDeleteHandle - Top-left control to delete entire table
 */
export const TableDeleteHandle: FC<TableDeleteHandleProps> = ({
  position,
  onDelete,
  isVisible,
}) => {
  const handleClick = useCallback(
    (e: React.MouseEvent) => {
      e.preventDefault();
      e.stopPropagation();
      onDelete();
    },
    [onDelete],
  );

  if (!isVisible || !position) {
    return null;
  }

  return (
    <div
      className={styles.deleteTableHandle}
      style={{ top: position.top, left: position.left }}
      title="Delete table"
      onClick={handleClick}
    >
      <Icon name="trash" popup={{ content: 'Delete Table' }} />
    </div>
  );
};
